import CharityDetailsModal from './CharityDetailsModal';

export default CharityDetailsModal;
